import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    Stack,
    Alert,
} from '@mui/material';
import RequestService from '../../services/RequestService';
import { toCents } from '../../utils/toCents';

const AdminDeletePlanDialog = ({ open, onClose, plan, onSuccess }) => {
    const [error, setError] = React.useState(null);
    const [submitting, setSubmitting] = React.useState(false);

    const handleSubmit = async () => {
        if (!plan?.id) return;
        try {
            setError(null);
            setSubmitting(true);
            await RequestService.deletePlanAsSuperAdmin(plan.id);
            onSuccess && onSuccess('Plano excluído com sucesso!');
            onClose && onClose();
        } catch (err) {
            console.error('Failed to delete plan:', err);
            setError('Falha ao excluir o plano. Tente novamente.');
        } finally {
            setSubmitting(false);
        }
    };

    if (!plan) return null;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Excluir plano</DialogTitle>

            <DialogContent sx={{ padding: '24px 32px' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: 16,
                            color: '#0C3466',
                            mb: 2,
                        }}
                    >
                        Essa ação é irreversível e removerá o plano do sistema.
                    </Typography>

                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: 14,
                            color: '#0C3466',
                            mb: 1,
                        }}
                    >
                        Informações do Plano
                    </Typography>

                    <Box
                        sx={{
                            padding: '16px',
                            backgroundColor: '#EDF8FF',
                            borderRadius: '8px',
                        }}
                    >
                        <Stack direction="column" spacing={1}>
                            <Typography
                                sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: 14,
                                    fontWeight: 500,
                                    color: '#292929',
                                }}
                            >
                                Nome: {plan.name}
                            </Typography>
                            <Typography
                                sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: 14,
                                    color: '#666666',
                                }}
                            >
                                Máx. usuários: {plan.maxUsers ?? '-'}
                            </Typography>
                            <Typography
                                sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: 14,
                                    color: '#666666',
                                }}
                            >
                                Valor mensal: {toCents(plan.priceCents)}
                            </Typography>
                            <Typography
                                sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: 14,
                                    color: '#666666',
                                }}
                            >
                                Ativo: {plan.active ? 'Sim' : 'Não'}
                            </Typography>
                        </Stack>
                    </Box>

                    {error && (
                        <Alert sx={{ mt: 2 }} severity="error">
                            {error}
                        </Alert>
                    )}
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} variant="outlined">
                    Cancelar
                </Button>
                <Button
                    onClick={handleSubmit}
                    color="error"
                    variant="contained"
                    disabled={submitting}
                >
                    {submitting ? 'Excluindo...' : 'Excluir plano'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AdminDeletePlanDialog;
